export default () => ({
    lightMode: false,

    init() {
        this.lightmode = false
    },

    toggle() {
        this.lightMode = ! this.lightMode
        if (this.lightMode == true) {
            document.body.setAttribute('data-light','')
        } else {
            document.body.removeAttribute('data-light')
        }
    },
})
